import { connect } from 'react-redux';

import { saveLegacy } from 'app/developer-v3/store/build/actions';
import {
  selectDefinitionOverride,
  selectIsAppVersionSaving,
} from 'app/developer-v3/store/selectors';

import LegacyWrapper from './LegacyWrapper';

const mapStateToProps = state => ({
  legacy: selectDefinitionOverride(state).legacy,
  isSaving: selectIsAppVersionSaving(state),
});

export default connect(mapStateToProps, { saveLegacy })(LegacyWrapper);
